
Checkout.Cart.Item.Option = function(item) {
	var option = this;

	this.$title =
	this.$desc  =
	this.$qty   =
	this.$brand =
	this.$brand =
	this.$row  =
		false;

	this.init = function(item) {
		option.$row = item.$contentsTmpl.clone(true).attr('id', '');
		item.$contentsTmpl.hide();

		option.$title = option.$row.find('.opt_title');
		option.$desc  = option.$row.find('.opt_desc');
		option.$qty   = option.$row.find('.opt_qty');
		option.$brand = option.$row.find('.opt_brand');
		item.$contentsTmpl.clone(true).attr('id', '');
		item.$optionContainer.append( option.$row );
	};

	this.add = function( response ) {
		if (response.pdkDescription && option.$title)
			option.$title.html( response.pdkDescription )
		else
			option.$title.addClass('hidden');
		if (response.description && option.$desc)
			option.$desc.html( response.description )
		if (response.qty && option.$qty)
			option.$qty.html( response.qty )
		if (response.brand && option.$brand )
			option.$brand.html( response.brand )

		option.$row.show();
		return option;

	};

	this.init(item);

};

